import { DATE_FORMATS, formatDate, formatDayOfTheWeek } from 'utilities/date.js';

export const createHeaderDetails = (date?: string): { headerName: string; headerDate: string } => {
  let headerName = '';
  let headerDate = '';

  if (date) {
    headerDate = formatDate(date, DATE_FORMATS.DateMonth);
    headerName = formatDayOfTheWeek(date);
  }

  return { headerName, headerDate };
};

export const ForecastTabLgBodyHeader = ({ title, date }: { title: string | undefined; date: string }) => {
  if (title) {
    return <h2>{title}</h2>;
  }

  const { headerName, headerDate } = createHeaderDetails(date);

  return (
    <h2>
      {headerName} {<span className="u-textRegular">{headerDate}</span>}
    </h2>
  );
};
